module.exports = __webpack_public_path__ + "img/hyperle.f94edccc.png";